import React from 'react'
import Image1withBG from "../../assets/borrower-page/Image1withBG.svg";
import { Box, Button, Container, Grid, InputLabel, Stack, TextField, Typography, } from "@mui/material";
import Background from "../../assets/borrower-page/Background.svg";
import stepProgress from "../../assets/borrower-page/stepProgress.png";

export default function Invitation() {
    return (
        <Grid container justifyContent="center" spacing={0}>
            <Grid item xs={11} md={11} lg={11} mt={4} mb={0} ml={0} mr={0}>
                <div>
                    {/* hero area start */}
                    <Box>

                        <Grid
                            container
                            minHeight="30vh"
                            alignItems="top"
                        //  pt={{ xs: 4, md: 5 }}
                        // pt={{ xs: 0, md: 0 }} // Adjusted padding top values
                        >
                            <Grid
                                item
                                xs={12}
                                md={5}
                                textAlign={{ xs: "center", md: "start" }}
                                //px={{ xs: 2 }}  //padding x-axis left
                                pt={{ xs: 0, md: 0 }} // Adjusted padding top values for text container



                            >
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    //   mb={2} mt={6}
                                    fontWeight={"bold"}
                                    lineHeight={"50px"}
                                >
                                    {`Get Invitations `}
                                </Typography>
                                <Typography variant="body1" mb={1}>
                                    {`Receive a personalized invitation to begin your mortgage application process with confidence. Your homeownership journey starts here.`}
                                </Typography>



                                {/* Text Content */}
                                <Box flexBasis="50%" p={0} mt={4} >
                                    {/* Step Progress Image */}
                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <div>
                                            <img src={stepProgress} alt="Step Progress" style={{ marginBottom: '4px', marginRight: '16px', alignSelf: 'flex-start' }} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ color: '#31B9B5' }} variant="h2" component="h1" fontWeight={400} fontSize={{ xs: "15px", md: "16px" }} lineHeight="20.83px" textAlign="justify">
                                                Contact Loan Officer
                                            </Typography>
                                            <Typography variant="body1" mb={5} fontWeight={400} fontSize="14px" lineHeight="18.23px" textAlign="justify">
                                                Reach out to our loan officers via phone, email, or website.
                                            </Typography>

                                        </div>
                                    </div>


                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <div>
                                            <img src={stepProgress} alt="Step Progress" style={{ marginBottom: '4px', marginRight: '16px', alignSelf: 'flex-start' }} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ color: '#31B9B5' }} variant="h2" component="h1" fontWeight={400} fontSize={{ xs: "15px", md: "16px" }} lineHeight="20.83px" textAlign="justify">
                                                Consultation
                                            </Typography>
                                            <Typography variant="body1" mb={5} fontWeight={400} fontSize="14px" lineHeight="18.23px" textAlign="justify">
                                                Discuss your mortgage needs and preferences.
                                            </Typography>

                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                        <div>
                                            <img src={stepProgress} alt="Step Progress" style={{ marginBottom: '4px', marginRight: '16px', alignSelf: 'flex-start' }} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                            <Typography sx={{ color: '#31B9B5' }} variant="h2" component="h1" fontWeight={400} fontSize={{ xs: "15px", md: "16px" }} lineHeight="20.83px" textAlign="justify">
                                                Personalized Invite
                                            </Typography>
                                            <Typography variant="body1" mb={5} fontWeight={400} fontSize="14px" lineHeight="18.23px" textAlign="justify">
                                                Receive your tailored invitation to begin the application process.
                                            </Typography>

                                        </div>
                                    </div>




                                </Box>





                            </Grid>

                            <Grid item md={2}></Grid>


                            {/* Intro Image */}
                            {/* Background Image with Overlay */}
                            <Grid item xs={12} md={5} >
                                <Box position="relative" my={{ md: "none", xs: 2 }} >
                                    {/* Background Image */}
                                    <img src={Background} width="100%" height="100%" />

                                    {/* Overlay Image */}
                                    <img
                                        src={Image1withBG} width={"100%"}
                                        //  width="515px"
                                        // height="363px"
                                        style={{
                                            position: "absolute", top: 0, left: 0,

                                            bottom: 0, // Align to the bottom of the parent container
                                            left: "50%", // Center horizontally
                                            transform: "translateX(-50%)" // Adjust horizontally to center

                                        }}
                                        alt="Overlay Image"


                                    />
                                </Box>
                            </Grid>
                        </Grid>

                    </Box>

                </div>
            </Grid>
        </Grid>
    )
}
